import { TermsPage } from 'src/modules/Terms/TermsPage';

export default TermsPage;
